import { useRef, useEffect, useContext } from 'react'
import styles from './nav.module.sass'
import classNames from 'classnames'

import Image from '../basic/image'
import Media from '../basic/media'
import Button from '../basic/button'
import ScrollAnimation from '../layout/scroll_animation'

import { AnnouncementContext } from '../context/announcementContext'

const globalData = JSON.parse(document.getElementById('global-data').innerHTML)
const navData = JSON.parse(document.getElementById('nav-data').innerHTML.replace(/&#038;/g, '&'))
const hostname = window.location.hostname

let hoverTimeout = null
let activeItem = null

const isMobile = () => {
	if (Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0) < 768)
		return true
	return false
}

function topLevel(item, type) {
	if(item.fields?.show_on_subnavigation_only){
		return
	}

	const target = (hostname == 'www.personalis.com' && item.classes.includes('investors')) ? '_blank' : ''
	const filteredChildren = item.children && type == 'main' ? item.children.filter((child) => !child.classes.includes('footer_only')) : item.children
	item.title = item.title.replace(/&#038;/g, '&')
	
	return <li key={item.db_id} className={classNames(styles[item.classes[0]], item.active_parent ? styles.active_parent : '', item.active ? styles.active : '')} onClick={(el) => toggleActiveMobile(el, item)}>
		<a href={item.url} target={target}>{item.title}{item.fields?.additional_text && <span style={{fontWeight: "400"}} className={styles.additional_text}> | {item.fields?.additional_text}</span>}</a>		
		{filteredChildren?.length > 0 && 
			<ul className={styles.subnav} data-subnav>
				<li className={styles.subnav_wrapper}>
					{item.fields?.subnavigation_statement && <div className={styles.subnav_statement}>{item.fields?.subnavigation_statement}</div>}

					<ul className={styles.subnav_items}>
						{filteredChildren.map((topLevelNavItem) => {							
							if(type == 'main' && topLevelNavItem.classes.includes('footer_only'))
								return

							return topLevel(topLevelNavItem)
						})}
					</ul>

					{item.fields?.call_to_action?.heading && 
						<div className={styles.subnav_cta_wrapper}>
							<a className={styles.subnav_cta} href={item.fields.call_to_action.button_clone.button.url} target={item.fields.call_to_action.button_clone.button.target}
                                onMouseOver={(e) => {
                                   e.currentTarget.querySelector(`.${styles.button}`).classList.add(styles.active)
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.querySelector(`.${styles.button}`).classList.remove(styles.active)
                                 }}>
								<div className={styles.thumbnail_wrapper}>
									<Media {...item.fields.call_to_action.thumbnail} sizeOverride='230px'className={styles.thumbnail} />
								</div>
								<div className={styles.content_wrapper}>
									<div className={styles.heading}>{item.fields.call_to_action.heading}</div>
									<div className={styles.content} dangerouslySetInnerHTML={{__html: item.fields.call_to_action.content}}></div>
									<Button 
										button_style='style_2'
										color='purple'
										className={styles.button}>
											{item.fields.call_to_action.button_clone.button.title}
									</Button>
								</div>
							</a>
						</div>
					}
				</li>
			</ul>
		}
	</li>
}

const toggleActiveMobile = (el, item) => {
	const navItem = el.currentTarget
	const navItemsActive = Array.from(el.currentTarget.parentNode.getElementsByClassName(styles.expandSubnav))

	if (!isMobile()) {
		return
	}

	if (!navItem.querySelector('[data-subnav]') || el.target != navItem.querySelector('a'))
		return

	const subnavWrapper = navItem.querySelector('[data-subnav]')
	const subnavItems = subnavWrapper.querySelector(`ul.${styles.subnav_items}`)

	if (subnavWrapper) {
		//find direct parent with styles.subnav class without using closest
		let parentSubnavWrapper = subnavWrapper.parentNode.parentNode.parentNode.parentNode.classList.contains(styles.subnav) ? subnavWrapper.parentNode.parentNode.parentNode.parentNode : null
		let parentSubnavItems = subnavWrapper.parentNode.parentNode.classList.contains(styles.subnav_items) ? subnavWrapper.parentNode.parentNode : null

		if (subnavWrapper.classList.contains(styles.expandSubnav)) {
			navItem.querySelector('a').classList.remove(styles.expandSubnav)
			subnavWrapper.classList.remove(styles.expandSubnav)
			subnavWrapper.style.height = null
			subnavItems.style.height = null

			//if there is a parentSubnav, subtract height of subnavWrapper to parentSubnav
			if (parentSubnavWrapper) {
				const parentSubnavHeight = parseInt(parentSubnavWrapper.getAttribute('data-height'))

				parentSubnavWrapper.style.height = parentSubnavHeight + 'px'
			}

			if (parentSubnavItems) {
				const parentSubnavHeight = parseInt(parentSubnavItems.getAttribute('data-height'))

				parentSubnavItems.style.height = parentSubnavHeight + 'px'
			}

			if(!parentSubnavWrapper && !parentSubnavItems){
				//set height to self height
				subnavWrapper.style.height = null
				subnavItems.style.height = null

				//find child subnavWrapper and subnavItems and close those too
				const childSubnavWrapper = subnavWrapper.querySelectorAll(`[data-subnav]`)
				const childSubnavItems = subnavWrapper.querySelectorAll(`ul.${styles.subnav_items}`)

				if(childSubnavWrapper){
					childSubnavWrapper.forEach((childSubnavWrapper) => {
						childSubnavWrapper.classList.remove(styles.expandSubnav)
						childSubnavWrapper.style.height = null
					})
				}

				if(childSubnavItems){
					childSubnavItems.forEach((childSubnavItems) => {
						childSubnavItems.style.height = null
					})
				}

			}
		} else {
			navItem.querySelector('a').classList.add(styles.expandSubnav)
			subnavWrapper.classList.add(styles.expandSubnav)
			subnavWrapper.style.height = subnavWrapper.getAttribute('data-height') + 'px'
			subnavItems.style.height = subnavItems.getAttribute('data-height') + 'px'

			//if there is a parentSubnav, add value of data-height attribute of subnavWrapper to parentSubnav
			if (parentSubnavWrapper) {
				const parentSubnavHeight = parseInt(parentSubnavWrapper.getAttribute('data-height'))
				const subnavWrapperHeight = parseInt(subnavWrapper.getAttribute('data-height'))

				parentSubnavWrapper.style.height = parentSubnavHeight + subnavWrapperHeight + 'px'
			}

			if (parentSubnavItems) {
				const parentSubnavHeight = parseInt(parentSubnavItems.getAttribute('data-height'))
				const subnavWrapperHeight = parseInt(subnavWrapper.getAttribute('data-height'))

				parentSubnavItems.style.height = parentSubnavHeight + subnavWrapperHeight + 'px'
			}
		}
	}

	if(navItemsActive) {
		navItemsActive.forEach((navItemActive) => {
			if(navItemActive != subnavWrapper){
				navItemActive.classList.remove(styles.expandSubnav)

				if(navItemActive.classList.contains(styles.subnav)){
					navItemActive.style.height = null
					const subnavItems = navItemActive.querySelector(styles.subnav_items)

					if(subnavItems){
						subnavItems.style.height = null
					}
				}
			}
		})
	}

	el.preventDefault()
	el.stopPropagation()
}

const toggleActiveDesktop = (item, tertiarySubNav, header, handleSearch, action) => {

	if (Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0) < 768)
		return

	let headerHeight = parseInt(header.getAttribute('height'))
	let subnavWrapper = null
	const expandedSubnav = document.querySelector(`.${styles.nav_wrapper} > li > ul.${styles.expandSubnav}`)
    let expandedTertiarySubnav = null

	if(handleSearch){
		handleSearch()
	}

    if(expandedSubnav) {
        expandedTertiarySubnav = expandedSubnav.querySelector(`ul.${styles.expandSubnav}`)
    }

	if (action == 'focusSubnav') {
		subnavWrapper = item.closest('[data-subnav]')
	} else {
		subnavWrapper = item.querySelector('[data-subnav]')
	}
	
	clearTimeout(hoverTimeout)
	if (action == 'enter') {
		activeItem = item
	} else if (action == 'leave') {
		// hoverTimeout = setTimeout(() => {
		// 	activeItem = null
		// }, 300)
	} else if (action == 'focus') {
		activeItem = item
	} else if (action == 'focusSubnav') {
		activeItem = item
	} else if (action == 'blur') {
		activeItem = null
	} else if (action == 'click') {
		activeItem = null
		item.blur()
	}

	if (activeItem) {
		if (subnavWrapper){
			let subNavHeight = parseInt(subnavWrapper.style.height, 10)

			if (action == 'leave' || action == 'blur') {
				// subnavWrapper.classList.remove(styles.expandSubnav)
				// subnavWrapper.setAttribute('expanded', false)
				// header.style.minHeight = null
			} else {
				if(tertiarySubNav == false){
					if (expandedSubnav){
						expandedSubnav.classList.remove(styles.expandSubnav)
						expandedSubnav.classList.remove('expanded')
						expandedSubnav.setAttribute('expanded', false)
						expandedSubnav.parentNode.querySelector('a').classList.remove(styles.expandSubnav)
					}

					if (expandedTertiarySubnav){
						expandedTertiarySubnav.classList.remove(styles.expandSubnav)
						expandedTertiarySubnav.classList.remove('expanded')
						expandedTertiarySubnav.setAttribute('expanded', false)
						expandedTertiarySubnav.parentNode.querySelector('a').classList.remove(styles.expandSubnav)
					}

					item.querySelector('a').classList.add(styles.expandSubnav)
					subnavWrapper.classList.add(styles.expandSubnav)
					subnavWrapper.setAttribute('expanded', true)
					header.style.minHeight = headerHeight + subNavHeight + "px"
				} else {
					if (expandedSubnav){
						if (expandedTertiarySubnav){
							expandedTertiarySubnav.classList.remove(styles.expandSubnav)
							expandedTertiarySubnav.classList.remove('expanded')
							expandedTertiarySubnav.setAttribute('expanded', false)
							expandedTertiarySubnav.parentNode.querySelector('a').classList.remove(styles.expandSubnav)
						}
					}

					item.querySelector('a').classList.add(styles.expandSubnav)
					subnavWrapper.classList.add(styles.expandSubnav)
					subnavWrapper.setAttribute('expanded', true)
				}
			}
		} else {
			if(expandedSubnav){
				if (expandedTertiarySubnav){
					expandedTertiarySubnav.classList.remove(styles.expandSubnav)
					expandedTertiarySubnav.classList.remove('expanded')
					expandedTertiarySubnav.setAttribute('expanded', false)
				}
			}
		}

	} else {
		if (subnavWrapper){
			// subnavWrapper.classList.remove(styles.expandSubnav)
			// subnavWrapper.setAttribute('expanded', false)
			// header.style.minHeight = headerHeight + "px"
		}
	}
}

const calculateSubnavs = (navItems) => {

	navItems.forEach((navItem) => {
		const subnavItems = navItem.querySelectorAll('ul')

		if(subnavItems){
			for(let i = 0; i < subnavItems.length; i++){
				const subnav = subnavItems[i]

				// const footerNavUnderline = navItem.parentNode.querySelector(`.${styles.hr}`)
				// const parentLIs = navItem.parentNode.querySelectorAll(':scope > li > a')
				// let maxHeight = 0

				// parentLIs.forEach((parentLI) => {
				// 	const parentLIHeight = parentLI.offsetHeight

				// 	if(parentLIHeight > maxHeight){
				// 		maxHeight = parentLIHeight
				// 	}
				// })
		
				// parentLIs.forEach((parentLI) => {
				// 	parentLI.style.height = maxHeight + 'px'
				// })

				// if(footerNavUnderline && maxHeight > 0){
				// 	footerNavUnderline.style.top = (maxHeight + 20) + 'px'
				// }

				//** commented out 164-166 and 169-170 to remove the subnavs from being pushed to the left with mega-menu
				// subnav.style.marginLeft = 0

				let subnavHeight = window.getComputedStyle(subnav).height
				//remove 'px' from subnavHeight
				subnavHeight = subnavHeight.substring(0, subnavHeight.length - 2)

				if (!isMobile()) {
					//calculate height of tallest UL child plus 60px for padding
					const tertiarySubnavHeight = Array.from(subnav.querySelectorAll('ul')).reduce((max, ul) => Math.max(max, ul.offsetHeight + 60), 0)

					if(tertiarySubnavHeight > subnavHeight){
						subnavHeight = tertiarySubnavHeight
					}
				} else {
					//subtract height of subnav child if exists
					// const childSubnavs = subnav.querySelectorAll(`.${styles.subnav}`)
					
					// if(childSubnavs){
					// 	childSubnavs.forEach((childSubnav) => {
					// 		const childSubnavHeight = childSubnav.offsetHeight

					// 		subnavHeight = subnavHeight - childSubnavHeight
					// 	})
					// }
				}


				// const rightEdge = subnav.offsetWidth + subnav.parentNode.getBoundingClientRect().left

				// if (rightEdge > window.innerWidth) {
				// 	subnav.style.marginLeft = (window.innerWidth - rightEdge - 30) + 'px'
				// }

				if(!subnav.classList.contains(styles.calculated)){
					const ctaThumbnail = subnav.querySelector(`.${styles.thumbnail} img`)
					subnav.setAttribute('data-height', subnavHeight)

					if(!isMobile()){
						subnav.style.height = subnavHeight + 'px'
					}

					if(ctaThumbnail && !isMobile()){
						//get subnav inner height without padding
						ctaThumbnail.style.maxHeight = subnavHeight - 62 + 'px'
					}
					
					subnav.classList.add(styles.calculated)
				}
			}
		}
	})
}

function Nav({handleSearch, collapseNav, ...props}) {
	const navRef = useRef(null)
	const items = props.items
	const type = props.type
	const theme = props.theme
	const mobileExpanded = props.mobileExpanded
	const compact = props.compact
	const collapse = props.collapse
	const {announcementHeight, heightChangeHandler} = useContext(AnnouncementContext)


	function calculateMarginTop(){
		let marginTop = 0

		if(type == 'main'){
			marginTop = announcementHeight
		}

		if(type == 'main' && isMobile && document.documentElement.scrollTop < announcementHeight){
			marginTop = (announcementHeight - document.documentElement.scrollTop)
		}

		if(type == 'main' && isMobile && document.documentElement.scrollTop > announcementHeight){
			marginTop = 0
		}

		return `${marginTop}px`
	}


	useEffect(() => {
		const navItems = navRef.current.querySelector('ul').childNodes

		if(type == "main"){
			const header = document.querySelector('[data-header]')

			navItems.forEach((navItem) => {
				if (navItem.tagName == 'LI') {
					navItem.querySelector('a').addEventListener('focus', toggleActiveDesktop.bind(null, navItem, false, header, '', 'focus'))
					navItem.querySelector('a').addEventListener('blur', toggleActiveDesktop.bind(null, navItem, false, header, '', 'blur'))
				}

				navItem.addEventListener('mouseenter', toggleActiveDesktop.bind(null, navItem, false, header, handleSearch, 'enter'))
				navItem.addEventListener('mouseleave', toggleActiveDesktop.bind(null, navItem, false, header, '', 'leave'))
			
				const subnav = navItem.querySelector('ul ul ul')

				if(subnav){
					const subnavItems = subnav.childNodes

					subnavItems.forEach((subnavItem) => {
						subnavItem.addEventListener('mouseenter', toggleActiveDesktop.bind(null, subnavItem, true, header, '', 'enter'))
						subnavItem.addEventListener('mouseleave', toggleActiveDesktop.bind(null, subnavItem, true, header, '','leave'))
					})

				}
			
			})

			header.querySelectorAll('[data-subnav] a').forEach((subnavItem) => {
				let tertiarySubNav = false

				if(subnavItem.closest('[data-subnav]').closest('[data-subnav]')){
					tertiarySubNav = true
				}

				subnavItem.addEventListener('focus', toggleActiveDesktop.bind(null, subnavItem, tertiarySubNav, header, '', 'focusSubnav'))
				subnavItem.addEventListener('click', toggleActiveDesktop.bind(null, subnavItem, tertiarySubNav, header, '', 'click'))
			})
		}

		window.addEventListener('resize', function() {calculateSubnavs(navItems)})

		return () => {
			window.removeEventListener('resize', function() {calculateSubnavs(navItems)})
		}
	}, [])

	useEffect(() => {
		if(collapse == true){
			const expandedSubnavs = document.querySelectorAll(`.${styles.expandSubnav}`)

			if(expandedSubnavs){
				expandedSubnavs.forEach((expandedSubnav) => {
					expandedSubnav.classList.remove(styles.expandSubnav)
					expandedSubnav.classList.remove('expanded')
				})
			}

			// const header = document.querySelector('[data-header]')
			// header.style.minHeight = null

			collapseNav()
		}
	}, [collapse])


	useEffect(() => {
		const navItems = navRef.current.querySelector('ul').childNodes
		calculateSubnavs(navItems)
	}, [compact])

	useEffect(() => {
		if(mobileExpanded == true){
			navRef.current.classList.add(styles.expanded)
		} else {
			navRef.current.classList.remove(styles.expanded)
		}
	}, [mobileExpanded])

	return <nav ref={navRef} className={classNames(styles.nav, styles[type], styles[theme], props.className, compact ? styles.compact : '')}>
		<ScrollAnimation styles={styles}>
			<ul className={styles.nav_wrapper} style={{marginTop: calculateMarginTop()}}>
				{items.map((topLevelNavItem) => {
					return topLevel(topLevelNavItem, type)
				})}
				
				<div className={styles.hr} />
			</ul>
		</ScrollAnimation>

		{type == 'main' &&
			<div className={styles.main_footer}>
				<hr />
				<div className={styles.copyright_menu}>
					<Nav items={navData.copyright_items} type='copyright' className={styles.copyright_nav} />
				</div>
				<div className={styles.social_wrapper}>
					{globalData.social_media && <ul>
						{globalData.social_media.map((social, index) => {
						return <li key={index} className={styles[social.platform]}>
							<a href={social.link} target='_blank'><Image {...{url: `/wp-content/themes/personalis/assets/icons/social/${social.platform}-grey.svg`}} className={styles.social_logo} /></a>
						</li>
						})}
					</ul>}
				</div>
			</div>
		}
	</nav>
}

export default Nav